<section style="background: #fff">
  <div class="upload-limit-info" *ngIf="sessionValidated && isStudent">
    <img src="../../../assets/report_v2/info-blue.svg" alt="">
    <p>You have <strong>{{ remainingUploads }} available</strong> Precheck Submissions</p>
  </div>

  <section class="precheck-external-container" aria-labelledby="submissions-heading">
    <!-- Token validation check -->
    <div *ngIf="!sessionValidated" class="token-error">
      <div class="error-container">
        <h2>Authentication Error</h2>
        <p>No valid session provided. This component can only be accessed with a valid external session.</p>
      </div>
    </div>

    <!-- Main content - only shown when token is valid -->
    <div *ngIf="sessionValidated" class="content">
      <!-- File Upload Section -->
      <div class="upload-section" role="region" aria-labelledby="upload-heading">
        <h2 id="upload-heading" class="sr-only">File Upload</h2>
        <p id="upload-description" class="sr-only">Upload a document to check for originality. You can use keyboard
          navigation to select files.</p>
        <app-input-text [isOnPrecheck]="true" [isStudent]="isStudent" [maxUploads]="maxPrecheckUploads" [remainingUploads]="remainingUploads"
          aria-describedby="upload-description"></app-input-text>
      </div>

      <!-- Submissions Table Section -->
      <div class="submissions-section" role="region" aria-labelledby="submissions-heading">
        <div class="submissions-header">
          <h2 id="submissions-heading">If the reports are still processing, refresh the list to check if they're complete.</h2>
          <button class="refresh-btn" (click)="refreshSubmissions()" title="Refresh submissions" tabindex="0"
            matTooltip="Reload results to view the latest originality reports." matTooltipPosition="above"
            matTooltipClass="new_report_tooltip">
            <!-- <img src="../../../assets/report_v2/refresh-double.svg" alt="Refresh icon"> -->
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.2285 7.29785C16.9426 4.35468 14.0058 2.29785 10.5886 2.29785C6.26745 2.29785 2.71449 5.58675 2.29639 9.79785" stroke="#0059B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.7552 7.29753H18.3219C18.6533 7.29753 18.9219 7.0289 18.9219 6.69753V3.13086" stroke="#0059B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2.98988 13.9639C4.27581 16.907 7.21261 18.9639 10.6298 18.9639C14.9509 18.9639 18.5039 15.675 18.922 11.4639" stroke="#0059B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.46301 13.9642H2.89635C2.56498 13.9642 2.29635 14.2328 2.29635 14.5642V18.1309" stroke="#0059B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            Refresh
          </button>
        </div>
        <div class="tableContainer" *ngIf="assignmentsSubmissions">
          <div class="table-wrapper">
            <table aria-label="Submissions table" [ngClass]="{'empty-table': !hasSubmissions()}">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Upload Time</th>
                  <th scope="col">Originality Index</th>
                  <th scope="col">Originality Report</th>
                </tr>
              </thead>
              <tbody *ngIf="hasSubmissions()">
                <tr *ngFor="let submission of getActiveSubmissions(); let i = index" [attr.data-index]="i">
                  <td>{{ submission.title }}</td>
                  <td>{{ submission.createdAt | localTime }}</td>
                  <td>
                    <ng-container *ngIf="submission.processed == 2; else notSuspended">
                      <span class="suspended-indicator" aria-label="Score calculation suspended">
                        N/A
                      </span>
                    </ng-container>

                    <ng-template #notSuspended>
                      <ng-container
                        *ngIf="isScoreLoading(submission.id) || submission.processed == 0 || submission.processed == -1; else hasScore">
                        <span class="processing-indicator" aria-label="Score is being processed">
                          Processing
                        </span>
                      </ng-container>

                      <ng-template #hasScore>
                        <ng-container *ngIf="getSubmissionScore(submission.id) !== null; else pendingScore">
                          <span class="risk-indicator" [ngClass]="getRiskLevel(getSubmissionScore(submission.id))"
                            role="status"
                            [attr.aria-label]="getRiskLevel(getSubmissionScore(submission.id)).replace('-', ' ') + ' originality index'">
                            {{ getSubmissionScore(submission.id) }}
                          </span>
                        </ng-container>

                        <ng-template #pendingScore>
                          <span class="pending-indicator" aria-label="Score calculation pending">
                            Pending
                          </span>
                        </ng-template>
                      </ng-template>
                    </ng-template>
                  </td>
                  <td class="report-btn-container">
                    <ng-container *ngIf="submission.processed == 1">
                      <button class="report-btn"
                        [disabled]="submission.hasOwnProperty('isPublic') && !submission.isPublic"
                        (click)="viewReport(submission.id)"
                        [attr.aria-label]="submission.title + ', submitted on ' + (submission.createdAt | localTime) + ', Originality index ' + (submission.processed == 1 && getSubmissionScore(submission.id) !== null ? getSubmissionScore(submission.id) : (submission.processed == 0 || submission.processed == -1 ? 'processing' : (submission.processed == 2 ? 'suspended' : 'pending')))"
                        tabindex="0">
                        View report
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8.33333 3.08789H4.16667C3.72464 3.08789 3.30072 3.26349 2.98816 3.57605C2.67559 3.88861 2.5 4.31253 2.5 4.75456V16.4212C2.5 16.8633 2.67559 17.2872 2.98816 17.5997C3.30072 17.9123 3.72464 18.0879 4.16667 18.0879H15.8333C16.2754 18.0879 16.6993 17.9123 17.0118 17.5997C17.3244 17.2872 17.5 16.8633 17.5 16.4212V12.2546"
                            stroke="#002E5C" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13.3333 3.08789H17.5V7.25456" stroke="#002E5C" stroke-width="1.7"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M17.5 3.08789L10 10.5879" stroke="#002E5C" stroke-width="1.7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </button>
                    </ng-container>
                    <ng-container *ngIf="submission.processed == 0 || submission.processed == -1">
                      <button class="report-btn disabled" [disabled]="true"
                        [attr.aria-label]="submission.title + ', submitted on ' + (submission.createdAt | localTime) + ', Originality index ' + (submission.processed == 0 || submission.processed == -1 ? 'processing' : (submission.processed == 2 ? 'suspended' : 'pending'))">
                        View report
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8.33333 3.08789H4.16667C3.72464 3.08789 3.30072 3.26349 2.98816 3.57605C2.67559 3.88861 2.5 4.31253 2.5 4.75456V16.4212C2.5 16.8633 2.67559 17.2872 2.98816 17.5997C3.30072 17.9123 3.72464 18.0879 4.16667 18.0879H15.8333C16.2754 18.0879 16.6993 17.9123 17.0118 17.5997C17.3244 17.2872 17.5 16.8633 17.5 16.4212V12.2546"
                            stroke="#002E5C" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13.3333 3.08789H17.5V7.25456" stroke="#002E5C" stroke-width="1.7"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M17.5 3.08789L10 10.5879" stroke="#002E5C" stroke-width="1.7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                        <!-- <img src="../../../assets/report_v2/" alt="View report"> -->
                      </button>
                    </ng-container>
                    <ng-container *ngIf="submission.processed == 2">
                      <button class="report-btn disabled" [disabled]="true"
                        [attr.aria-label]="submission.title + ', submitted on ' + (submission.createdAt | localTime) + ', Originality index ' + (submission.processed == 2 ? 'suspended' : 'pending')">
                        Suspended
                      </button>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!hasSubmissions()">
                <tr>
                  <td colspan="4" class="no-submissions">
                    Your document uploads will show up here.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="hasSubmissions()" class="pagination-container" role="navigation" aria-label="Pagination controls">
            <div class="items-per-page">
              <label for="page-size-select">Show:</label>
              <select id="page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()"
                aria-label="Select number of items per page">
                <option [value]="5">5 items</option>
                <option [value]="10" *ngIf="totalSubmissions >= 10">10 items</option>
                <option [value]="25" *ngIf="totalSubmissions >= 25">25 items</option>
                <option [value]="50" *ngIf="totalSubmissions >= 50">50 items</option>
              </select>
            </div>

            <div class="page-indicator" role="status" aria-live="polite">
              {{ totalSubmissions > 0 ? ((page - 1) * pageSize) + 1 : 0 }} - {{
              (page * pageSize) > totalSubmissions
              ? totalSubmissions
              : (page * pageSize)
              }} of {{ totalSubmissions }}
            </div>

            <div class="pagination-controls">
              <button class="pagination-arrow prev" [disabled]="page === 1" (click)="changePage(page - 1)"
                aria-label="Previous page" tabindex="0">
                <span class="arrow" aria-hidden="true">&#10094;</span>
              </button>
              <button class="pagination-arrow next" [disabled]="page * pageSize >= totalSubmissions"
                (click)="changePage(page + 1)" aria-label="Next page" tabindex="0">
                <span class="arrow" aria-hidden="true">&#10095;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
